/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as AppRouteImport } from './routes/app'
import { Route as RobotsDottxtRouteImport } from './routes/robots[.]txt'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as LangBeyondSourcingRouteImport } from './routes/$lang/beyond-sourcing'
import { Route as LangContactRouteImport } from './routes/$lang/contact'
import { Route as LangFaqRouteImport } from './routes/$lang/faq'
import { Route as LangHowWeWorkRouteImport } from './routes/$lang/how-we-work'
import { Route as LangManufacturingNetworkRouteImport } from './routes/$lang/manufacturing-network'
import { Route as LangPrivacyRouteImport } from './routes/$lang/privacy'
import { Route as LangTermsRouteImport } from './routes/$lang/terms'
import { Route as ApiRfqRouteImport } from './routes/api/rfq'
import { Route as LangDivisionsIndexRouteImport } from './routes/$lang/divisions/index'
import { Route as LangDivisionsSlugRouteImport } from './routes/$lang/divisions/$slug'
import { Route as LangMarketsIndexRouteImport } from './routes/$lang/markets/index'
import { Route as LangMarketsSlugRouteImport } from './routes/$lang/markets/$slug'
import { Route as LangRfqIndexRouteImport } from './routes/$lang/rfq/index'
import { Route as LangRfqFlowRouteImport } from './routes/$lang/rfq/$flow'
import { Route as LangRfqReceivedRouteImport } from './routes/$lang/rfq/received'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangRoute = LangRouteImport.update({
  id: '/$lang',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const RobotsDottxtRoute = RobotsDottxtRouteImport.update({
  id: '/robots.txt',
  path: '/robots.txt',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LangRoute,
} as any)
const LangAboutRoute = LangAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LangRoute,
} as any)
const LangBeyondSourcingRoute = LangBeyondSourcingRouteImport.update({
  id: '/beyond-sourcing',
  path: '/beyond-sourcing',
  getParentRoute: () => LangRoute,
} as any)
const LangContactRoute = LangContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LangRoute,
} as any)
const LangFaqRoute = LangFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => LangRoute,
} as any)
const LangHowWeWorkRoute = LangHowWeWorkRouteImport.update({
  id: '/how-we-work',
  path: '/how-we-work',
  getParentRoute: () => LangRoute,
} as any)
const LangManufacturingNetworkRoute =
  LangManufacturingNetworkRouteImport.update({
    id: '/manufacturing-network',
    path: '/manufacturing-network',
    getParentRoute: () => LangRoute,
  } as any)
const LangPrivacyRoute = LangPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LangRoute,
} as any)
const LangTermsRoute = LangTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LangRoute,
} as any)
const ApiRfqRoute = ApiRfqRouteImport.update({
  id: '/api/rfq',
  path: '/api/rfq',
  getParentRoute: () => rootRouteImport,
} as any)
const LangDivisionsIndexRoute = LangDivisionsIndexRouteImport.update({
  id: '/divisions/',
  path: '/divisions/',
  getParentRoute: () => LangRoute,
} as any)
const LangDivisionsSlugRoute = LangDivisionsSlugRouteImport.update({
  id: '/divisions/$slug',
  path: '/divisions/$slug',
  getParentRoute: () => LangRoute,
} as any)
const LangMarketsIndexRoute = LangMarketsIndexRouteImport.update({
  id: '/markets/',
  path: '/markets/',
  getParentRoute: () => LangRoute,
} as any)
const LangMarketsSlugRoute = LangMarketsSlugRouteImport.update({
  id: '/markets/$slug',
  path: '/markets/$slug',
  getParentRoute: () => LangRoute,
} as any)
const LangRfqIndexRoute = LangRfqIndexRouteImport.update({
  id: '/rfq/',
  path: '/rfq/',
  getParentRoute: () => LangRoute,
} as any)
const LangRfqFlowRoute = LangRfqFlowRouteImport.update({
  id: '/rfq/$flow',
  path: '/rfq/$flow',
  getParentRoute: () => LangRoute,
} as any)
const LangRfqReceivedRoute = LangRfqReceivedRouteImport.update({
  id: '/rfq/received',
  path: '/rfq/received',
  getParentRoute: () => LangRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/app': typeof AppRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/beyond-sourcing': typeof LangBeyondSourcingRoute
  '/$lang/contact': typeof LangContactRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/how-we-work': typeof LangHowWeWorkRoute
  '/$lang/manufacturing-network': typeof LangManufacturingNetworkRoute
  '/$lang/privacy': typeof LangPrivacyRoute
  '/$lang/terms': typeof LangTermsRoute
  '/api/rfq': typeof ApiRfqRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/divisions/$slug': typeof LangDivisionsSlugRoute
  '/$lang/markets/$slug': typeof LangMarketsSlugRoute
  '/$lang/rfq/$flow': typeof LangRfqFlowRoute
  '/$lang/rfq/received': typeof LangRfqReceivedRoute
  '/$lang/divisions/': typeof LangDivisionsIndexRoute
  '/$lang/markets/': typeof LangMarketsIndexRoute
  '/$lang/rfq/': typeof LangRfqIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/beyond-sourcing': typeof LangBeyondSourcingRoute
  '/$lang/contact': typeof LangContactRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/how-we-work': typeof LangHowWeWorkRoute
  '/$lang/manufacturing-network': typeof LangManufacturingNetworkRoute
  '/$lang/privacy': typeof LangPrivacyRoute
  '/$lang/terms': typeof LangTermsRoute
  '/api/rfq': typeof ApiRfqRoute
  '/$lang': typeof LangIndexRoute
  '/$lang/divisions/$slug': typeof LangDivisionsSlugRoute
  '/$lang/markets/$slug': typeof LangMarketsSlugRoute
  '/$lang/rfq/$flow': typeof LangRfqFlowRoute
  '/$lang/rfq/received': typeof LangRfqReceivedRoute
  '/$lang/divisions': typeof LangDivisionsIndexRoute
  '/$lang/markets': typeof LangMarketsIndexRoute
  '/$lang/rfq': typeof LangRfqIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang': typeof LangRouteWithChildren
  '/app': typeof AppRoute
  '/robots.txt': typeof RobotsDottxtRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/$lang/about': typeof LangAboutRoute
  '/$lang/beyond-sourcing': typeof LangBeyondSourcingRoute
  '/$lang/contact': typeof LangContactRoute
  '/$lang/faq': typeof LangFaqRoute
  '/$lang/how-we-work': typeof LangHowWeWorkRoute
  '/$lang/manufacturing-network': typeof LangManufacturingNetworkRoute
  '/$lang/privacy': typeof LangPrivacyRoute
  '/$lang/terms': typeof LangTermsRoute
  '/api/rfq': typeof ApiRfqRoute
  '/$lang/': typeof LangIndexRoute
  '/$lang/divisions/$slug': typeof LangDivisionsSlugRoute
  '/$lang/markets/$slug': typeof LangMarketsSlugRoute
  '/$lang/rfq/$flow': typeof LangRfqFlowRoute
  '/$lang/rfq/received': typeof LangRfqReceivedRoute
  '/$lang/divisions/': typeof LangDivisionsIndexRoute
  '/$lang/markets/': typeof LangMarketsIndexRoute
  '/$lang/rfq/': typeof LangRfqIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/app'
    | '/robots.txt'
    | '/sitemap.xml'
    | '/$lang/about'
    | '/$lang/beyond-sourcing'
    | '/$lang/contact'
    | '/$lang/faq'
    | '/$lang/how-we-work'
    | '/$lang/manufacturing-network'
    | '/$lang/privacy'
    | '/$lang/terms'
    | '/api/rfq'
    | '/$lang/'
    | '/$lang/divisions/$slug'
    | '/$lang/markets/$slug'
    | '/$lang/rfq/$flow'
    | '/$lang/rfq/received'
    | '/$lang/divisions/'
    | '/$lang/markets/'
    | '/$lang/rfq/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/robots.txt'
    | '/sitemap.xml'
    | '/$lang/about'
    | '/$lang/beyond-sourcing'
    | '/$lang/contact'
    | '/$lang/faq'
    | '/$lang/how-we-work'
    | '/$lang/manufacturing-network'
    | '/$lang/privacy'
    | '/$lang/terms'
    | '/api/rfq'
    | '/$lang'
    | '/$lang/divisions/$slug'
    | '/$lang/markets/$slug'
    | '/$lang/rfq/$flow'
    | '/$lang/rfq/received'
    | '/$lang/divisions'
    | '/$lang/markets'
    | '/$lang/rfq'
  id:
    | '__root__'
    | '/'
    | '/$lang'
    | '/app'
    | '/robots.txt'
    | '/sitemap.xml'
    | '/$lang/about'
    | '/$lang/beyond-sourcing'
    | '/$lang/contact'
    | '/$lang/faq'
    | '/$lang/how-we-work'
    | '/$lang/manufacturing-network'
    | '/$lang/privacy'
    | '/$lang/terms'
    | '/api/rfq'
    | '/$lang/'
    | '/$lang/divisions/$slug'
    | '/$lang/markets/$slug'
    | '/$lang/rfq/$flow'
    | '/$lang/rfq/received'
    | '/$lang/divisions/'
    | '/$lang/markets/'
    | '/$lang/rfq/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangRoute: typeof LangRouteWithChildren
  AppRoute: typeof AppRoute
  RobotsDottxtRoute: typeof RobotsDottxtRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  ApiRfqRoute: typeof ApiRfqRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang': {
      id: '/$lang'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/robots.txt': {
      id: '/robots.txt'
      path: '/robots.txt'
      fullPath: '/robots.txt'
      preLoaderRoute: typeof RobotsDottxtRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/about': {
      id: '/$lang/about'
      path: '/about'
      fullPath: '/$lang/about'
      preLoaderRoute: typeof LangAboutRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/beyond-sourcing': {
      id: '/$lang/beyond-sourcing'
      path: '/beyond-sourcing'
      fullPath: '/$lang/beyond-sourcing'
      preLoaderRoute: typeof LangBeyondSourcingRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/contact': {
      id: '/$lang/contact'
      path: '/contact'
      fullPath: '/$lang/contact'
      preLoaderRoute: typeof LangContactRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/faq': {
      id: '/$lang/faq'
      path: '/faq'
      fullPath: '/$lang/faq'
      preLoaderRoute: typeof LangFaqRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/how-we-work': {
      id: '/$lang/how-we-work'
      path: '/how-we-work'
      fullPath: '/$lang/how-we-work'
      preLoaderRoute: typeof LangHowWeWorkRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/manufacturing-network': {
      id: '/$lang/manufacturing-network'
      path: '/manufacturing-network'
      fullPath: '/$lang/manufacturing-network'
      preLoaderRoute: typeof LangManufacturingNetworkRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/privacy': {
      id: '/$lang/privacy'
      path: '/privacy'
      fullPath: '/$lang/privacy'
      preLoaderRoute: typeof LangPrivacyRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/terms': {
      id: '/$lang/terms'
      path: '/terms'
      fullPath: '/$lang/terms'
      preLoaderRoute: typeof LangTermsRouteImport
      parentRoute: typeof LangRoute
    }
    '/api/rfq': {
      id: '/api/rfq'
      path: '/api/rfq'
      fullPath: '/api/rfq'
      preLoaderRoute: typeof ApiRfqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/divisions/': {
      id: '/$lang/divisions/'
      path: '/divisions'
      fullPath: '/$lang/divisions/'
      preLoaderRoute: typeof LangDivisionsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/divisions/$slug': {
      id: '/$lang/divisions/$slug'
      path: '/divisions/$slug'
      fullPath: '/$lang/divisions/$slug'
      preLoaderRoute: typeof LangDivisionsSlugRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/markets/': {
      id: '/$lang/markets/'
      path: '/markets'
      fullPath: '/$lang/markets/'
      preLoaderRoute: typeof LangMarketsIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/markets/$slug': {
      id: '/$lang/markets/$slug'
      path: '/markets/$slug'
      fullPath: '/$lang/markets/$slug'
      preLoaderRoute: typeof LangMarketsSlugRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/rfq/': {
      id: '/$lang/rfq/'
      path: '/rfq'
      fullPath: '/$lang/rfq/'
      preLoaderRoute: typeof LangRfqIndexRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/rfq/$flow': {
      id: '/$lang/rfq/$flow'
      path: '/rfq/$flow'
      fullPath: '/$lang/rfq/$flow'
      preLoaderRoute: typeof LangRfqFlowRouteImport
      parentRoute: typeof LangRoute
    }
    '/$lang/rfq/received': {
      id: '/$lang/rfq/received'
      path: '/rfq/received'
      fullPath: '/$lang/rfq/received'
      preLoaderRoute: typeof LangRfqReceivedRouteImport
      parentRoute: typeof LangRoute
    }
  }
}

interface LangRouteChildren {
  LangAboutRoute: typeof LangAboutRoute
  LangBeyondSourcingRoute: typeof LangBeyondSourcingRoute
  LangContactRoute: typeof LangContactRoute
  LangFaqRoute: typeof LangFaqRoute
  LangHowWeWorkRoute: typeof LangHowWeWorkRoute
  LangManufacturingNetworkRoute: typeof LangManufacturingNetworkRoute
  LangPrivacyRoute: typeof LangPrivacyRoute
  LangTermsRoute: typeof LangTermsRoute
  LangIndexRoute: typeof LangIndexRoute
  LangDivisionsSlugRoute: typeof LangDivisionsSlugRoute
  LangMarketsSlugRoute: typeof LangMarketsSlugRoute
  LangRfqFlowRoute: typeof LangRfqFlowRoute
  LangRfqReceivedRoute: typeof LangRfqReceivedRoute
  LangDivisionsIndexRoute: typeof LangDivisionsIndexRoute
  LangMarketsIndexRoute: typeof LangMarketsIndexRoute
  LangRfqIndexRoute: typeof LangRfqIndexRoute
}

const LangRouteChildren: LangRouteChildren = {
  LangAboutRoute: LangAboutRoute,
  LangBeyondSourcingRoute: LangBeyondSourcingRoute,
  LangContactRoute: LangContactRoute,
  LangFaqRoute: LangFaqRoute,
  LangHowWeWorkRoute: LangHowWeWorkRoute,
  LangManufacturingNetworkRoute: LangManufacturingNetworkRoute,
  LangPrivacyRoute: LangPrivacyRoute,
  LangTermsRoute: LangTermsRoute,
  LangIndexRoute: LangIndexRoute,
  LangDivisionsSlugRoute: LangDivisionsSlugRoute,
  LangMarketsSlugRoute: LangMarketsSlugRoute,
  LangRfqFlowRoute: LangRfqFlowRoute,
  LangRfqReceivedRoute: LangRfqReceivedRoute,
  LangDivisionsIndexRoute: LangDivisionsIndexRoute,
  LangMarketsIndexRoute: LangMarketsIndexRoute,
  LangRfqIndexRoute: LangRfqIndexRoute,
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangRoute: LangRouteWithChildren,
  AppRoute: AppRoute,
  RobotsDottxtRoute: RobotsDottxtRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  ApiRfqRoute: ApiRfqRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
